import { render, staticRenderFns } from "./warehouseWood.vue?vue&type=template&id=c3419e98&scoped=true&"
import script from "./warehouseWood.vue?vue&type=script&lang=js&"
export * from "./warehouseWood.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3419e98",
  null
  
)

export default component.exports